import * as yup from 'yup';

export const schema = yup.object().shape({
  password: yup.string()
    .matches(
      /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/,
      'Password must contain at least 8 characters, one uppercase, one number and one special case character'
    ).required('Please create a password'),
  confirmPassword: yup.string().required('Passwords must match')
    .oneOf([yup.ref('password'), null], 'Passwords must match')
});
